
let knowHcpManagerEmail = true;
let dinHcpHasError = false;
let fundingStatus = "";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phonePattern = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;

const deliScheduleDivHcp = document.querySelector(".delivery-schedule__wrapper");
const openDeliveryCheckForHCP = document.getElementById(`open-deli-schedule-div-for-hcp`);
const hcpManagerEmailTick = document.querySelector(`#din-hcp-v2-case-manager-email .din-custom-v2-hcp-option`);
const hcpManagerEmailMandatoryMark = document.getElementById(`hcp-case-manager-email-mandatory`);
const fundingStatusOptions = document.querySelectorAll(`#din-hcp-v2-funding-status .din-custom-v2-hcp-option`);
const fundingStatusSelector = document.getElementById(`din-hcp-v2-funding-status`);
const sahCaseManagerSection = document.querySelector(`.sah-case-manager-section`);
const dinHcpFormMainWrap = document.querySelector(`.din-custom-v2-hcp-wrapper`);
const dinHcpFormWaitWrap = document.querySelector(`.din-custom-v2-hcp-wrapper-wait`);
const dinHcpFormResultWrap = document.querySelector(`.din-custom-v2-hcp-container-result`);
const dinHcpFormBotResultWrap = document.querySelector(`.din-custom-v2-bot-hcp-container-result`);

const clearDinHcpErrorWrapperDisplay = function () {
  document.querySelectorAll('.din-hcp-v2-error-wrapper').forEach(wrapper => {
    if (wrapper.style.display === 'flex') {
      wrapper.style.removeProperty('display');
    }
  });
};

const updateCaseManagerSectionVisibility = function () {
  if (!sahCaseManagerSection) return;
  const hasFunding = fundingStatus === "have-funding";
  sahCaseManagerSection.classList.toggle("hidden", !hasFunding);
  if (!hasFunding) {
    document.getElementById(`din-hcp-v2-manager-email-address`).style.border = "";
  }
};

updateCaseManagerSectionVisibility();

openDeliveryCheckForHCP.addEventListener("click", function (e) {
  e.preventDefault();
  if (deliScheduleDivHcp) {
    deliScheduleDivHcp.classList.add("active");
  }
});

if (hcpManagerEmailTick) {
  hcpManagerEmailTick.addEventListener("click", function (e) {
    e.preventDefault();
    clearDinHcpErrorWrapperDisplay();
    hcpManagerEmailTick.classList.toggle("selected");
    hcpManagerEmailMandatoryMark.classList.toggle("hidden");
    knowHcpManagerEmail = !knowHcpManagerEmail;
    if (!knowHcpManagerEmail) {
      document.getElementById(`din-hcp-v2-manager-email-address`).style.border = "";
    }
  });
}

fundingStatusOptions.forEach(option => {
  option.addEventListener("click", function (e) {
    e.preventDefault();
    clearDinHcpErrorWrapperDisplay();
    fundingStatusOptions.forEach(item => item.classList.remove("selected"));
    option.classList.add("selected");
    fundingStatus = option.dataset.option || "";
    if (fundingStatusSelector) {
      fundingStatusSelector.classList.remove("din-hcp-v2-funding-error");
    }
    updateCaseManagerSectionVisibility();
  });
});

document.getElementById('din-cv2hf').addEventListener('submit', function(e) {
  e.preventDefault();
  const submitBtnDinHcpV2 = document.querySelector(`.din-Hcp-v2-hcp-submit`);
  const dinHcpGetVal = id => document.getElementById(id)?.value?.trim() || "";
  const dinHcpGetInput = id => document.getElementById(id) || "";
  const hcpFormData = {
    firstName: dinHcpGetVal(`din-hcp-v2-first-name`),
    lastName: dinHcpGetVal(`din-hcp-v2-last-name`),
    email: dinHcpGetVal(`din-hcp-v2-email-address`),
    phone: dinHcpGetVal(`din-hcp-v2-phone`),
    managerEmail: dinHcpGetVal(`din-hcp-v2-manager-email-address`),
    fundingStatus: fundingStatus,
    website: dinHcpGetVal(`din-hcp-v2-website`)
  };
  const hcpFormDataInputField = {
    firstName: dinHcpGetInput(`din-hcp-v2-first-name`),
    lastName: dinHcpGetInput(`din-hcp-v2-last-name`),
    email: dinHcpGetInput(`din-hcp-v2-email-address`),
    phone: dinHcpGetInput(`din-hcp-v2-phone`),
    managerEmail: dinHcpGetInput(`din-hcp-v2-manager-email-address`)
  }
  const showDinHcpErrorHeading = function () {
    document.querySelectorAll('.din-hcp-v2-error-wrapper').forEach(wrapper => {
      wrapper.style.display = 'flex';
    });
    const dinHcpErrorHeading = document.getElementById("din-hcp-v2-error-heading");
    if (!dinHcpErrorHeading.textContent) {
      dinHcpErrorHeading.textContent = "Please provide the following information and try again.";
    }
  }
  const dinShowHcpError = function (field) {
    const fieldLabels = {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      phone: "Phone Number",
      managerEmail: "Plan Manager's Email Address"
    };       
    const isEmailField = ["email", "managerEmail"].includes(field);
    const isPhoneField = ["phone"].includes(field);
    const fieldValue = hcpFormData[field];
    const inputElement = hcpFormDataInputField[field];
    let isValid = true;
    let isFieldEmpty;
    if (isEmailField) {
      isValid = emailPattern.test(fieldValue);
      isFieldEmpty = !fieldValue?.trim();
    } else if (isPhoneField) {
      isValid = phonePattern.test(fieldValue);
      isFieldEmpty = !fieldValue?.trim();
    } else {
      isValid = Boolean(fieldValue);
    }
    if (!isValid) {
      dinHcpHasError = true;
      showDinHcpErrorHeading();
      inputElement.style.border = "0.8px solid red";
      if ((isEmailField || isPhoneField) && !isFieldEmpty) {
        dinHcpErrorList.insertAdjacentHTML('beforeend', `<li>${fieldLabels[field]} is not formatted properly.</li>`);
      } else {
        dinHcpErrorList.insertAdjacentHTML('beforeend', `<li>${fieldLabels[field]}</li>`);
      }
    }
    console.log("field: ", field);
    console.log("isValid: ", isValid);
    console.log("dinHcpHasError: ", dinHcpHasError)
  };
  const checkEachDinHcpField = function (arr, isRequired) {
    for (const field of arr) {
      if (isRequired) {
        dinShowHcpError(field);
      } else if (hcpFormData[field]?.trim()) {
        dinShowHcpError(field);
      }
    }
  }
  const dinHcpErrorList = document.getElementById("din-hcp-v2-error-list");
  if (dinHcpErrorList) {
    dinHcpErrorList.innerHTML = '';
  }
  if (fundingStatusSelector) {
    fundingStatusSelector.classList.remove("din-hcp-v2-funding-error");
  }
  Object.values(hcpFormDataInputField).forEach(input => {
    if (input && input.style.border === '0.8px solid red') {
      input.style.border = ''
    }
  });
  console.log("Form submission data: ", hcpFormData);
  if (!hcpFormData.website) {
    dinHcpHasError = false;
    let hcpRequiredFields = ["firstName", "lastName", "email", "phone"];
    if (!hcpFormData.fundingStatus) {
      dinHcpHasError = true;
      showDinHcpErrorHeading();
      dinHcpErrorList.insertAdjacentHTML('beforeend', `<li>Support at Home funding status</li>`);
      if (fundingStatusSelector) {
        fundingStatusSelector.classList.add("din-hcp-v2-funding-error");
      }
    }
    if (hcpFormData.fundingStatus === "have-funding") {
      hcpRequiredFields.push("managerEmail");
    }
    console.log("knowHcpManagerEmail: ", knowHcpManagerEmail);
    if (hcpFormData.fundingStatus === "have-funding" && !knowHcpManagerEmail) {
      hcpRequiredFields = hcpRequiredFields.filter(field => field !== "managerEmail");
      hcpFormData.managerEmail = "unknown-plan-manager-email@dineamic.com.au";
    } else if (hcpFormData.fundingStatus !== "have-funding") {
      hcpFormData.managerEmail = "";
    }
    checkEachDinHcpField(hcpRequiredFields, true);
    if (!dinHcpHasError) {
      const melbTime = new Date().toLocaleTimeString("en-AU", {
        timeZone: "Australia/Melbourne",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
      dinHcpFormMainWrap.classList.add("hidden");
      dinHcpFormWaitWrap.classList.remove("hidden");
      document.getElementById('hcp-enquiry-form-anchor').scrollIntoView({ behavior: 'smooth' });
      grecaptcha.ready(function () {
        grecaptcha.execute("6LcdMH8rAAAAADgT5wqXYGrVT2zB19e7b1AA341F", { action: "submit_form" }).then(function (token) {
          const flowParamsEmbeddedVarHcp = JSON.stringify({
            firstName: `${hcpFormData.firstName}`,
            lastName: `${hcpFormData.lastName}`,
            email: `${hcpFormData.email}`,
            phone: `${hcpFormData.phone}`,
            managerEmail: `${hcpFormData.managerEmail}`,
            fundingStatus: `${hcpFormData.fundingStatus}`,
            knowManagerEmail: knowHcpManagerEmail,
            recaptchaToken: `${token}`,
            melbTime: `${melbTime}`,
          });
          const queryParamsHcp = new URLSearchParams({
            requestId: "41133e20-190f-11f1-b00a-072ce40dcdb4",
            flowParamsEmbedded: flowParamsEmbeddedVarHcp,
          });
          fetch('/apps/apiease/integration/caller/call?' + queryParamsHcp).
            then(function(response) {return response.json();}).
            then(function(jsonResponseHcp) {
              console.log(jsonResponseHcp);
              dinHcpFormWaitWrap.classList.add("hidden");
              if (jsonResponseHcp.data.googleRecaptureStatus === "success") {
                if(fundingStatus === "have-funding" && knowHcpManagerEmail) {
                  dinHcpFormResultWrap.insertAdjacentHTML('beforeend', `
                    <div class="ff-heading section-header__heading fs-heading-3-base">✅ You're Almost There!</div>
                    <div class="fs-body-100">Thanks for getting in touch — you're just one step away from enjoying our delicious chef-made meals.</div>
                    <div class="fs-body-100">We've just emailed your SaH Case Manager a form to complete and return to us. Once we receive it, we'll be in touch to guide you through placing your first Dineamic order.</div>
                  `);
                } else if (fundingStatus === "have-funding" && !knowHcpManagerEmail) {
                  dinHcpFormResultWrap.insertAdjacentHTML('beforeend', `
                    <div class="ff-heading section-header__heading fs-heading-3-base">✅ You're Almost There!</div>
                    <div class="fs-body-100">Thanks for getting in touch — you're just one step away from enjoying our delicious chef-made meals.</div>
                    <div class="fs-body-100">We’ve just sent you an email with a form to forward to your SaH Case Manager. Once your Case Manager completes and returns the form, we’ll get in touch to help you place your very first Dineamic order!</div>
                  `);
                } else {
                  dinHcpFormResultWrap.insertAdjacentHTML('beforeend', `
                    <div class="ff-heading section-header__heading fs-heading-3-base">✅ You're Almost There!</div>
                    <div class="fs-body-100">Thanks for getting in touch — you're just one step away from enjoying our delicious chef-made meals.</div>
                    <div class="fs-body-100">We’ve just sent you an email with the final details to complete your first order${jsonResponseHcp.data?.dinCustomerType === "new" ? ", along with an exclusive welcome offer" : ""}. If you need any help placing your first Dineamic order, feel free to contact our friendly customer service team — we’re always happy to help.</div>
                  `);
                }
                dinHcpFormResultWrap.classList.remove("hidden");
              } else if (jsonResponseHcp.data.googleRecaptureStatus === "failure") {
                // FIXME: show hide appropriate blocks when form is submitted.
                dinHcpFormBotResultWrap.classList.remove("hidden");
              }
            });
        });
      });
    }
  }
});
document.querySelectorAll(`.din-hcp-v2-input-value`).forEach(input => {
  input.addEventListener('input', (event) => {
    event.preventDefault();
    clearDinHcpErrorWrapperDisplay();
    const inputType = input.getAttribute('type');
    const value = input.value.trim();

    if (input.id === 'din-hcp-v2-manager-email-address') {
      if (knowHcpManagerEmail && !emailPattern.test(value)) {
        input.style.border = "0.8px solid red";
      } else {
        input.style.border = "";
      }
    } else if (inputType === 'email') {
      if (emailPattern.test(value)) {
        input.style.border = "";
      } else {
        input.style.border = "0.8px solid red";
      }
    } else if (inputType === 'tel') {
      if (phonePattern.test(value)) {
        input.style.border = "";
      } else {
        input.style.border = "0.8px solid red";
      }
    } else {
      if (input.style.border === "0.8px solid red") {
        input.style.border = "";
      }
    }
  });
});